// Upload-Lift's original-upload events are the authority for saved references.
// One completed original is sufficient for a group photo or separate photos.
// Every selected file must finish; pending/failed files never count as completed.
window.LaPhotoUploadCompletion = class {
  constructor(root, signal, changed = () => {}) {
    this.root = root;
    this.completed = new Set();
    this.removed = false;
    root.addEventListener('upload:added', event => {
      const { url, meta } = event.detail || {};
      if (typeof url !== 'string' || !/^https:\/\//.test(url) || meta?.variant === 'thumbnail') return;
      this.completed.add(url);
      this.removed = false;
      changed();
    }, { signal });
    root.addEventListener('upload:removed', event => {
      this.completed.delete(event.detail?.url);
      this.removed = true;
      changed();
    }, { signal });
    // FilePond updates state on retry/removal without always emitting app events.
    // Observe lifecycle state only; leave the app's files, fields and limits alone.
    const observer = new MutationObserver(changed);
    observer.observe(root, { subtree: true, childList: true, attributes: true,
      attributeFilter: ['data-filepond-item-state', 'value'] });
    signal?.addEventListener('abort', () => observer.disconnect(), { once: true });
  }
  references(data) {
    return [...data].filter(([key, value]) => /^properties\[Pet Photo(?:_\d+)?\]$/i.test(key) &&
      typeof value === 'string' && value.trim());
  }
  status(data, minimum = 1) {
    const uploader = this.root.querySelector('[data-upload-lift] input[type="file"]');
    if (!uploader) return 'unavailable';
    const photos = this.references(data);
    const items = [...this.root.querySelectorAll('[data-upload-lift] [data-filepond-item-state]')];
    const states = items.map(item => item.getAttribute('data-filepond-item-state'));
    if (states.some(state => /error|failed|invalid/i.test(state))) return 'failed';
    if (states.some(state => state !== 'processing-complete')) return 'uploading';
    if (photos.length >= minimum && photos.every(([, url]) => this.completed.has(url)) && states.length >= minimum) return 'completed';
    if (states.length) return 'unverified';
    return this.removed ? 'removed' : 'missing';
  }
  ready(data) {
    return this.status(data) === 'completed';
  }
};
